<template>
  <el-container
    class="userManagement-box"
    v-loading="loading"
    direction="vertical"
  >
    <el-tabs v-model="activeName" v-if="!loading" @tab-click="handleClick">
      <el-tab-pane label="健康评估" name="health">
        <router-view v-if="activeName == 'health'" />
      </el-tab-pane>
      <el-tab-pane label="体检信息" name="report">
        <router-view v-if="activeName == 'report'" />
      </el-tab-pane>
      <el-tab-pane label="基本信息" name="basic">
        <BasicInfo v-if="activeName == 'basic'" />
      </el-tab-pane>
      <el-tab-pane label="服务使用记录" name="record">
        <Examination v-if="activeName == 'record'" />
      </el-tab-pane>
    </el-tabs>
    <el-button size="mini" @click="toBack" class="back">返回</el-button>
  </el-container>
</template>
<script>
import BasicInfo from "./components/BasicInfo";
import Examination from "./components/Examination";
import HealthAssessment from "./health/HealthAssessment";
import ReportInfo from "./components/ReportInfo";
export default {
  name: "UserDetail",
  components: {
    BasicInfo,
    Examination,
    HealthAssessment,
    ReportInfo,
  },
  data() {
    return {
      activeName: "health",
      loading: true,
    };
  },
  created() {
    // 面包导航
    this.$root.breadList = [
      { name: "用户管理", link: "" },
      { name: "用户档案", link: "" },
      { name: "详情", link: "" },
    ];
    this.$store.state.healthDocUser = JSON.parse(
      sessionStorage.getItem("health-user")
    );
    this.getUserProfileId();
    this.activeName = this.$route.query.type
      ? this.$route.query.type
      : "health";
  },
  methods: {
    handleClick(tab, event) {
      let query = {
        type: this.activeName,
        userId: this.$store.state.healthDocUser.userId,
      };
      switch (this.activeName) {
        case "report":
          this.$router.push({ name: "体检基础信息", query });
          break;
        case "basic":
        case "record":
          this.$router.push({ name: "userDetail", query });
          break;
        case "health":
          this.$router.push({ name: "健康档案", query });
          break;
      }
    },
    /**
     * 获取数据
     */
    async getUserProfileId(resetPage) {
      this.loading = true;
      let res = await this.axios.get(this.getApiUrl("userProfileId"), {
        params: {
          userId: this.$store.state.healthDocUser.userId,
        },
      });
      this.$store.state.healthDocUser.isDoc = false;
      this.$store.state.healthDocUser.profileId = res?.data?.profileId || "";
      sessionStorage.setItem(
        "health-user",
        JSON.stringify(this.$store.state.healthDocUser)
      );
      this.loading = false;
    },
    toBack() {
      this.$router.replace({
        name: "userManagement",
      });
    },
  },
};
</script>
<style lang="scss">
.userManagement-box {
  position: relative;
  .back {
    position: absolute;
    right: 0;
    top: 0px;
  }
}
</style>
